import { GET_REGISTRATION_USERSCHEMA } from '../../actions/registration_userschema/registration_userschema';

const getInitialState = {
  error: null,
  loaded: false,
  loading: false,
  userschema: {},
};

/**
 * registrationUserschema reducer.
 * @function registrationUserschema
 * @param {Object} state Current state.
 * @param {Object} action Action to be handled.
 * @returns {Object} New state.
 */
export const registrationUserschemaReducer = (
  state = getInitialState,
  action = {},
) => {
  switch (action.type) {
    case `${GET_REGISTRATION_USERSCHEMA}_PENDING`:
      return {
        ...state,
        error: null,
        loaded: false,
        loading: true,
        userschema: {},
      };
    case `${GET_REGISTRATION_USERSCHEMA}_FAIL`:
      return {
        ...state,
        error: action.error,
        loaded: false,
        loading: false,
        userschema: {},
      };
    case `${GET_REGISTRATION_USERSCHEMA}_SUCCESS`:
      return {
        ...state,
        error: null,
        loaded: true,
        loading: false,
        userschema: action.result,
      };
    default:
      return state;
  }
};
